<template>
	<ValidationObserver v-slot="{ invalid, validated, passes, validate, handleSubmit, errors, failed, failedRules }"
	                    ref="observer">
		<v-dialog v-model="dialog" max-width="700px" :fullscreen="$vuetify.breakpoint.mdAndDown || dialogFullScreen"
		          :hide-overlay="$vuetify.breakpoint.mdAndDown" scrollable
		          no-click-animation v-if="show">
			<template v-slot:activator="{ on, attrs }" v-if="!hideButton">
				<v-btn color="primary"
				       v-bind="attrs"
                       :class="buttonCssClasses"
                       :block="buttonDisplayBlock"
				       v-on="on">
					<v-icon left>
						mdi-message-processing
					</v-icon>
					Demander des avis
				</v-btn>
			</template>

			<v-card>
				<v-toolbar dark color="primary" :max-height="$vuetify.breakpoint.mdAndUp ? 64 : 56">
					<v-btn icon dark @click="closeDialog">
						<v-icon>mdi-close</v-icon>
					</v-btn>
					<v-toolbar-title class="pl-0">Demander des avis par SMS</v-toolbar-title>
					<v-progress-linear
						:active="saveLoading"
						:indeterminate="saveLoading"
						absolute
						bottom
						color="lime"
					></v-progress-linear>
					<div class="flex-grow-1"></div>
					<v-toolbar-items>
						<v-btn v-if="$vuetify.breakpoint.mdAndUp" icon @click="dialogFullScreen = !dialogFullScreen">
							<v-icon v-if="dialogFullScreen === true">mdi-fullscreen-exit</v-icon>
							<v-icon v-if="dialogFullScreen === false">mdi-fullscreen</v-icon>
						</v-btn>
						<!--					  <v-btn dark text @click="passes(submit)">-->
						<!--						  <v-icon>mdi-content-save-outline</v-icon>-->
						<!--					  </v-btn>-->
					</v-toolbar-items>
				</v-toolbar>
				<v-card-text class="px-5 pt-5 pb-0">
					<v-form :loading="loading" ref="form" @submit.prevent="handleSubmit(submit)">

						<v-autocomplete
							v-show="showUnitField"
							v-model="unit"
							:items="units"
							:loading="unitsLoading"
							:disabled="loading"
							:prefix="getSelectedUnitText()"
							return-object
							item-key="id"
							outlined
							class="mb-5"
							@blur="unitsSearchInput = ''"
							item-text="name"
							menu-props="closeOnClick"
							:search-input.sync="unitsSearchInput"
							hide-details
							dense
						>
							<template v-slot:selection="{ item, index }">

							</template>

							<template slot="label">
								Lieu concerné
							</template>
							<!-- item -->
							<template v-slot:item="{ item }">
								<v-list-item-content>
									<v-list-item-title>{{ item.name }}</v-list-item-title>
									<v-list-item-subtitle>{{ item.address }}</v-list-item-subtitle>
								</v-list-item-content>
							</template>
						</v-autocomplete>

						<!-- sender name -->
						<VTextFieldWithValidation
							v-model="sender"
							minlength="3"
							maxlength="11"
							:label="'Expéditeur ' + sender.length +'/11'"
							outlined
							:rules="{ required: true, regex: '^[a-zA-Z0-9 ]{3,11}$' }"
							:disabled="loading"
							name="sms_sender_name"
							dense
						/>

						<v-row>
							<v-col cols="12">
								<span class="mt-5 d-inline-block mr-1 ml-2" v-if="recipients.length === 0"
								      @click="add_recipient_dialog = true"
								      style="cursor: pointer;">Destinataire(s)</span>
								<v-chip
									class="mt-3 ml-2"
									close
									color="primary"
									label
									text-color="white"
									v-for="(recipient, index) in recipients"
									:key="recipient.mobile"
									@click:close="removeRecipient(recipient)"
								>
									<div class="line-height-normal">
										<span v-if="recipient.name">{{ recipient.name }}</span> {{ recipient.mobile }}
									</div>
								</v-chip>
								<v-btn v-show="!loading && recipients.length < maxRecipient"
								       @click="add_recipient_dialog = true" color="primary" elevation="0" fab x-small
								       class="float-left mt-3 mb-1">
									<v-icon>mdi-plus</v-icon>
								</v-btn>
								<v-dialog
									v-model="add_recipient_dialog"
									max-width="500px"
								>
									<v-card>
										<v-container>
											<v-row>
												<v-col
													cols="12"
												>
													<v-text-field
														v-model="newRecipient.name"
														maxlength="15"
														outlined
														hide-details
														dense
													>
														<template slot="label">
															Nom (facultatif)
														</template>
													</v-text-field>
												</v-col>

												<v-col
													cols="12"
													class="pb-0"
												>
													<v-text-field
														v-model="newRecipient.mobile"
														maxlength="13"
														minLength="12"
														ref="mobileInput"
														required
														outlined
														dense
													>
														<template slot="label">
															Numéro de mobile
														</template>
													</v-text-field>
												</v-col>

												<v-col cols="12 py-0">
													<small class="caption">Liz n'enregistre aucune
														information
														permettant
														d'identifier les destinataires.</small>
												</v-col>
											</v-row>
										</v-container>

										<v-card-actions>
											<v-spacer></v-spacer>
											<v-btn
												color="primary"
												elevation="0"
												:disabled="recipients.length >= 10"
												@click="() => {add_recipient_dialog = false; newRecipient = Object.assign({}, defaultRecipient);}"
											>
												Fermer
											</v-btn>
											<v-btn
												color="primary"
												elevation="0"
												:disabled="!canAddNewPhoneNumber"
												@click="addNewRecipient(newRecipient)"
											>
												Ajouter
											</v-btn>
										</v-card-actions>
									</v-card>
								</v-dialog>
							</v-col>
						</v-row>

						<!-- SMS content -->
						<v-text-area-with-validation
							v-model="content"
							:label="'Message ' + content.length +'/300'"
							:counter="false"
							:disabled="loading"
							rows="3"
							name="message"
							rules="required"
							outlined
							classes="mt-8"
							dense>
						</v-text-area-with-validation>

            <v-alert
                v-if="displayError"
                border="top"
                colored-border
                type="error"
                elevation="2"
            >
              <p>Une erreur est survenue: {{errorMessage}}</p>
              <!--<pre>{{debugData}}</pre>-->
            </v-alert>

						<!-- submit -->
						<div v-if="unit && content.length">

							<v-checkbox
								v-model="consent"
								:disabled="loading"
								hide-details
								class="mt-0 pt-0 consent-checkbox"
							>
								<template v-slot:label>
									<small>
										Le<span v-if="recipients.length > 1">s</span> destinataire<span
										v-if="recipients.length > 1">s</span>
										m'{{ recipients.length > 1 ? 'ont' : 'a' }} donné
										{{ recipients.length > 1 ? 'leur' : 'son' }} accord
										pour utiliser {{ recipients.length > 1 ? 'leurs' : 'ses' }} données
										personnelles afin de {{ recipients.length > 1 ? 'leur' : 'lui' }} envoyer ce
										message
									</small>
								</template>
							</v-checkbox>
						</div>
					</v-form>
				</v-card-text>
				<v-card-actions class="pa-5">
					<v-spacer></v-spacer>
					<v-btn
						:loading="loading"
						:disabled="!canSubmitSmsSend"
						color="primary"
						@click="passes(submit)"
					>
						Envoyer {{ recipients.length ? recipients.length : '' }} SMS
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

	</ValidationObserver>
</template>

<script>
import {ValidationObserver} from 'vee-validate';
import VTextFieldWithValidation from '../../communs/inputs/VTextFieldWithValidation';
import VTextAreaWithValidation from '../../communs/inputs/VTextAreaWithValidation';
import ModelLogic from "../../../logics/ModelLogic";
import _ from "lodash";
import Helpers from "@/services/Helpers";
import AuthLogic from "../../../logics/AuthLogic";
import {EventBus} from "@/services/Request";
import GlobalFiltersStore from "@/stores/GlobalFiltersStore";

export default {
	name: 'rating-sms-solicitation-form',

	props: {
        buttonCssClasses: {
            type: [String],
            default: '',
        },
        buttonDisplayBlock: {
            type: [Boolean],
            default: false,
        },
        hideButton: {
            type: [Boolean],
            default: false,
        }
    },

	components: {
		VTextAreaWithValidation,
		ValidationObserver,
		VTextFieldWithValidation,
	},

	data: () => ({
		GlobalFiltersStore,
		dialog: false,
		dialogFullScreen: false,
		saveLoading: false,
		showUnitField: false,

		Helpers,
		AuthLogic,
		editedIndex: -1,
		loading: false,
		show: false,
		panel: false,
    debugData: [],
    displayError: false,
    errorMessage: '',

		//unit
		unit: null,
		units: [],
		unitsLoading: false,
		unitsSearchInput: '',

		//recipients
		recipients: [],

		defaultRecipient: {
			mobile: '+33',
			name: ''
		},
		newRecipient: null,
		add_recipient_dialog: false,
		maxRecipient: 10,

		//sender
		sender: 'Liz',

		//content
		content: '',

		//consent
		consent: false,
	}),

	created() {
		this.getUnits(true);
		this.newRecipient = _.cloneDeep(this.defaultRecipient);
	},

	mounted() {

	},

	computed: {
		languages() {
			return Object.keys(this.$i18n.messages);
		},
		canAddNewPhoneNumber() {

			//length check
			if (!this.newRecipient.mobile || this.newRecipient.mobile.length < 10) {
				return false;
			}

			//already exist
			let exist = _.filter(this.recipients, (o) => {
				return o.mobile === this.newRecipient.mobile.replace(/(\+\d{2})0/g, "$1");
			});

			if (exist.length) {
				return false;
			}

			//regex check
			let regex = new RegExp('^\\+\\d{11,12}$', 'i');

			return regex.test(this.newRecipient.mobile)
		},

		canSubmitSmsSend() {
			return this.consent && this.$refs.form.validate() && this.unit && this.recipients.length && this.content.length && this.sender.length;
		}
	},
	watch: {
		unitsSearchInput(val) {
			this.getUnits(val, ['email'])
		},
		unit(val) {
			if (val) {
        this.sender = val.name;

        if(this.sender.length > 11) {
          this.sender = this.sender.split(' ')[0];
        }

				this.sender = this.sender.substr(0, 11).normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-zA-Z0-9 ]/g, "");
				this.consent = false;
				this.content = 'Bonjour {nom}\n' +
          'Nous serions ravis d’avoir votre avis suite à votre visite chez nous !\n' +
					'Choix 1 : Cliquez ici {lien_app_liz} pour partager votre expérience.\n' +
					'Choix 2 : Cliquez ici {lien_feedback_liz} pour partager votre expérience sur Google ou nous transmettre directement vos impressions.\n' +
					'Merci !';
			}
		},
	},

	methods: {
		getSelectedUnitText() {
			if (this.unit) {
				return this.unit.name
			}
		},

		openDialog() {
			return new Promise(resolve => {
				this.dialog = true;
				resolve()
			})
		},

		closeDialog() {
			return new Promise(resolve => {
				this.dialog = false;
				resolve()
			})
		},

		async submit() {
			this.loading = true;
      this.debugData = [];
      this.errorMessage = '';
      this.displayError = false;

			ModelLogic
				.store('solicitations/ratings/sms', {
					unit: this.unit,
					sender: this.sender,
					content: this.content,
					recipients: this.recipients
				})
				.then((result) => {
					this.consent = false;
          console.log(result);

          if(result.errors && result.errors.length) {
            this.debugData = result;
            this.displayError = true;

            console.log('SMS send error:', result.errors);

            this.errorMessage = result.errors.join(', ');

            EventBus.$emit('show-snackbar', {
              text: 'Une erreur est survenue lors de l\'envoi de la demande d\'avis: ' + result.errors.join(', '),
              timeout: 6000,
              color: 'error'
            })
          } else {
            this.closeDialog()

            EventBus.$emit('show-snackbar', {
              text: result.sent + '/' + result.to_send + ' SMS envoyés avec succès',
              timeout: 5000,
              color: parseInt(result.sent) === parseInt(result.to_send) ? 'success' : 'error'
            })
          }

				})
				.catch((error) => {
					console.error('SMS send error:', error, error.response)
          EventBus.$emit('show-snackbar', {
            text: 'Une erreur est survenue lors de l\'envoi de la demande d\'avis: ' + error.response?.data?.message,
            timeout: 5000,
            color: 'error'
          })
          // get error content

				})
				.finally(() => {
					this.loading = false;
				})
		},

		addNewRecipient(newRecipient) {
			this.recipients.push(_.merge(newRecipient, {
				mobile: newRecipient.mobile.replace(/(\+\d{2})0/g, "$1"),
				name: newRecipient.name
			}));

			this.add_recipient_dialog = false;
			this.newRecipient = _.cloneDeep(this.defaultRecipient);
		},

		removeRecipient(item) {
			this.recipients.splice(item.index, 1)
		},

		getUnits: _.debounce(function (first_search) {
			this.unitsLoading = true;

			ModelLogic
				.getAll('units', {
						sortBy: ['name'],
						//sortDesc: [1],
						page: 1,
						limit: 20
					},
					{
						search: this.unitsSearchInput,
						where_active_feedback_or_app: true,
						where_enabled: true
					}, 'GET')
				.then(({units, totalItems}) => {
					this.units = units;
					if (first_search && units.length > 1) {
						this.showUnitField = true
					}
					if (!this.show && this.units.length) {
						this.unit = this.units[0];
						this.show = true;
					}
				})
				.catch((err) => {
					console.error(err)
				})
				.finally(() => {
					this.unitsLoading = false;
				})
		}, 400),
	},
};
</script>